import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 类别列表
  categoryList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/category/categoryList?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
  // 类别详情
  categoryDetail(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/category/categoryDetail?${parameterChange(data)}`,
      method: 'get',
    });
  },
  // 类别新增
  categoryAdd(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/category/categoryAdd`,
      method: 'post',
      data,
    });
  },
  // 类别编辑
  categoryUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/category/categoryUpdate`,
      method: 'post',
      data,
    });
  },
  // 类别删除
  categoryDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/category/categoryDelete`,
      method: 'post',
      data,
    });
  },
  // 获取类别间隔
  getcategoryInterval(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/category/getcategoryInterval`,
      method: 'get',
      data,
    });
  },
  // 更新类别间隔
  updatecategoryInterval(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/category/updatecategoryInterval`,
      method: 'post',
      data,
    });
  },
};
